import * as React from 'react';
import { Dialog } from '../dialog/Dialog';
import { DialogBody } from '../dialog/DialogBody';
import { Button } from '../button/Button';
import { DialogFooter } from '../dialog/DialogFooter';
import { Card } from '../card/Card';
import { Block } from '../block/Block';
import { FilterDef } from './Filters';
import { useMemo, useState } from 'react';
import { MultiSelectSearch } from '../multiselect/MultiSelectSearch';
import { ModalComponentProps } from '../modal/ModalManager';
import { Tag } from '../tag/Tag';
import { CloseButton } from '../button/CloseButton';

type Props = {
  filtersDef: FilterDef[];
  visibleFields?: string[];
  onChange: (visibleFields: string[]) => void;
  filledFilterFields: string[];
} & ModalComponentProps;

export const ManageVisibleFieldsModalForm: React.FC<Props> = ({
  filtersDef,
  visibleFields,
  onChange,
  filledFilterFields,
  onClose,
}) => {
  const [checkedFields, setCheckedFields] = useState<string[]>(() => {
    if (visibleFields) {
      return visibleFields;
    } else {
      const vf = filtersDef.map((x) => x.name);
      return vf;
    }
  });

  const items = useMemo(() => {
    return filtersDef.map((x) => ({ id: x.name, name: x.label }));
  }, [filtersDef]);

  return (
    <Dialog size={'lg'} onClose={onClose} title={'Výběr položek filtru'}>
      <DialogBody>
        <Card mode={'edit'}>
          <Block>
            <MultiSelectSearch
              renderItem={(item) => {
                return (
                  <div>
                    {item.name}
                    {filledFilterFields.indexOf(item.id) >= 0 && (
                      <Tag
                        className={'float-right'}
                        title={'Dle pole je filtrováno'}
                      >
                        filtrováno
                      </Tag>
                    )}
                  </div>
                );
              }}
              hideCloseButton
              value={checkedFields}
              onChange={(ids) => {
                setCheckedFields(ids);
              }}
              items={items}
            />
          </Block>
        </Card>
      </DialogBody>
      <DialogFooter>
        <CloseButton onClick={onClose}>Storno</CloseButton>
        <Button
          dataTest={'submit'}
          style={'primary'}
          onClick={() => {
            onChange(checkedFields);
          }}
        >
          Změnit
        </Button>
      </DialogFooter>
    </Dialog>
  );
};
